import { COLORS, RADIUS, fontFamilyFor } from "../../theme";

const heading = (isArabic) => ({
  fontFamily: isArabic ? fontFamilyFor("ar") : "'Playfair Display', serif",
  fontWeight: 700,
});

export const Style = {
  page: {
    minHeight: "100vh",
  },
  hero: {
    textAlign: "center",
    padding: { xs: "48px 20px 32px", md: "80px 48px 40px" },
    maxWidth: "900px",
    mx: "auto",
  },
  heroTitle: (isArabic) => ({
    ...heading(isArabic),
    fontSize: { xs: "36px", md: "56px" },
    background: `linear-gradient(135deg, #fff 0%, ${COLORS.peach} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    mb: "16px",
  }),
  subtitle: {
    fontSize: { xs: "16px", md: "20px" },
    color: "rgba(255,255,255,0.7)",
  },
  container: {
    maxWidth: "1200px",
    mx: "auto",
    px: { xs: "20px", md: "48px" },
    pb: { xs: "48px", md: "96px" },
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
    gap: { xs: "32px", md: "64px" },
  },
  formSection: {
    background: COLORS.gray,
    padding: { xs: "24px 20px", md: "48px" },
    borderRadius: RADIUS.card,
    border: "1px solid rgba(255,255,255,0.05)",
  },
  sectionHeading: (isArabic) => ({
    ...heading(isArabic),
    fontSize: "32px",
    color: COLORS.peach,
    mb: "24px",
  }),
  bodyText: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "17px",
    lineHeight: 1.7,
    mb: "32px",
  },
  emailCard: {
    background: COLORS.forest,
    padding: { xs: "32px 20px", md: "40px 32px" },
    borderRadius: RADIUS.card,
    textAlign: "center",
  },
  emailIcon: {
    width: "48px",
    height: "48px",
    color: COLORS.peach,
    marginBottom: "20px",
  },
  emailHeading: (isArabic) => ({
    ...heading(isArabic),
    color: COLORS.white,
    fontSize: "20px",
    mb: "8px",
  }),
  emailBody: {
    color: "rgba(255,255,255,0.7)",
    mb: "24px",
  },
  emailLink: {
    color: COLORS.peach,
    fontSize: "24px",
    fontWeight: 700,
    textDecoration: "none",
    cursor: "pointer",
  },
  infoItem: {
    background: COLORS.gray,
    padding: "32px",
    borderRadius: RADIUS.card,
    marginBottom: "24px",
    border: "1px solid rgba(255,255,255,0.05)",
  },
  infoIcon: {
    width: "22px",
    height: "22px",
    verticalAlign: "middle",
    marginInlineEnd: "10px",
  },
  infoTitle: (isArabic) => ({
    display: "flex",
    alignItems: "center",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontSize: "18px",
    fontWeight: 700,
    color: COLORS.white,
    mb: "10px",
  }),
  infoBody: {
    color: "rgba(255,255,255,0.65)",
    lineHeight: 1.6,
  },
  salesCard: {
    background: COLORS.forest,
    padding: "32px",
    borderRadius: RADIUS.card,
    marginTop: "32px",
    textAlign: "center",
  },
  salesHeading: (isArabic) => ({
    ...heading(isArabic),
    color: COLORS.peach,
    fontSize: "20px",
    mb: "16px",
  }),
  salesBody: {
    color: "rgba(255,255,255,0.8)",
    mb: "24px",
  },
  salesPhone: {
    color: COLORS.peach,
    fontSize: "24px",
    fontWeight: 700,
    textDecoration: "none",
  },
};
